<script>
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm.vue";

export default {
  components: { ForgotPasswordForm },
  name: "ForgotPassword"
};
</script>
<template>
  <ForgotPasswordForm></ForgotPasswordForm>
</template>
<style></style>
